import script from "./BaseSet.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSet.vue?vue&type=script&setup=true&lang=js"

import "./BaseSet.vue?vue&type=style&index=0&id=2dbbd8c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dbbd8c0"]])

export default __exports__